<template>
    <div class="mobile-header">
        <el-row class="header-conainer" v-bind:class="{'fixed': !top}">
            <el-col :span="16">
                <img src="../assets/imgs/logo.png" style="width: 70%; height: auto; float: left; margin-bottom: 10px;"/>
            </el-col>
            <el-col :span="8" @click.native="showMenu = !showMenu">
                <img src="../assets/imgs/home/mobile/menu.svg" style="width: 30%; height: auto; float: right;"/>
            </el-col>
        </el-row>

        <div class="DrawerWindow" id="menu" style="position: fixed;z-index:8888;" v-bind:class="{'show': showMenu}">
            <div class="cu-list menu card-menu" >
                <div class="cu-item arrow" data-cur="home" @click="toPage('/')" v-bind:class="{'menu-selected': active === 'home'}">
                    <div class="content">
                        <span class="cuIcon-home text-black padding-right"></span>
                        <span class="text-black">首页</span>
                    </div>
                </div>
                <div class="cu-item arrow" hover-class="backgroundcolor" data-cur="about" @click="toPage('/about')" v-bind:class="{'menu-selected': active === 'about'}">
                    <div class="content">
                        <span class="cuIcon-vipcard text-black padding-right"></span>
                        <span class="text-black">关于我们</span>
                    </div>
                </div>
                <div class="cu-item arrow" hover-class="backgroundcolor" data-cur="news" @click="toPage('/news')" v-bind:class="{'menu-selected': active === 'news'}">
                    <div class="content">
                        <span class="cuIcon-news text-black padding-right"></span>
                        <span class="text-black">新闻中心</span>
                    </div>
                </div>
                <div class="cu-item arrow" hover-class="backgroundcolor" data-cur="focus" @click="toPage('/business')" v-bind:class="{'menu-selected': active === 'business'}">
                    <div class="content">
                        <span class="cuIcon-focus text-black padding-right"></span>
                        <span class="text-black">业务聚焦</span>
                    </div>
                </div>
                <div class="cu-item arrow" hover-class="backgroundcolor" data-cur="intellectual" @click="toPage('/intellectual')" v-bind:class="{'menu-selected': active === 'intellectual'}">
                    <div class="content">
                        <span class="cuIcon-read text-black padding-right"></span>
                        <span class="text-black">知识产权</span>
                    </div>
                </div>
                <div class="cu-item arrow" hover-class="backgroundcolor" data-cur="focus" @click="toPage('/solution')" v-bind:class="{'menu-selected': active === 'solution'}">
                    <div class="content">
                        <span class="cuIcon-post text-black padding-right"></span>
                        <span class="text-black">解决方案</span>
                    </div>
                </div>
                <div class="cu-item arrow" hover-class="backgroundcolor" data-cur="party" @click="toPage('/party')" v-bind:class="{'menu-selected': active === 'party'}">
                    <div class="content">
                        <span class="cuIcon-hot text-black padding-right"></span>
                        <span class="text-black">党建专题</span>
                    </div>
                </div>
                <div class="cu-item arrow" hover-class="backgroundcolor" data-cur="public" @click="toPage('/welfare')" v-bind:class="{'menu-selected': active === 'welfare'}">
                    <div class="content">
                        <span class="cuIcon-like text-black padding-right"></span>
                        <span class="text-black">公益事业</span>
                    </div>
                </div>
                <div class="cu-item arrow last-menu" hover-class="backgroundcolor" data-cur="job" @click="toPage('/jobs')" v-bind:class="{'menu-selected': active === 'job'}">
                    <div class="content">
                        <span class="cuIcon-friendadd text-black padding-right"></span>
                        <span class="text-black">人才招聘</span>
                    </div>
                </div>
                <!--<div class="cu-item arrow" hover-class="backgroundcolor" data-cur="culture">-->
                    <!--<div class="content">-->
                        <!--<span class="cuIcon-we text-black"></span>-->
                        <!--<span class="text-black">愿景与文化</span>-->
                    <!--</div>-->
                <!--</div>-->
                <!--<div class="cu-item arrow" hover-class="backgroundcolor" data-cur="ceo">-->
                    <!--<div class="content">-->
                        <!--<span class="cuIcon-my text-black"></span>-->
                        <!--<span class="text-black">董事长致辞</span>-->
                    <!--</div>-->
                <!--</div>-->


                <!--<div class="cu-item arrow" hover-class="backgroundcolor" data-cur="solution">-->
                    <!--<div class="content">-->
                        <!--<span class="cuIcon-post text-black"></span>-->
                        <!--<span class="text-black">解决方案</span>-->
                    <!--</div>-->
                <!--</div>-->



            </div>
        </div>

        <div v-if="showMenu" v-bind:style="{height: height + 'px'}" class="ovride" @click="showMenu = false">

        </div>
    </div>
</template>

<script>
    export default {
        name: "MobileHeader",
        props: {
            active: {
                type: String
            }
        },
        data () {
            return {
                showMenu: false,
                top: true,
                height: document.body.scrollHeight
            }
        },
        mounted() {
            window.addEventListener(
                'scroll',
                () => {
                    if (this.onPageScroll) {
                        this.onPageScroll.call(this, window.scrollY);
                        this.height = document.body.scrollHeight;
                    }
                },
                true
            );
            this.height = document.body.scrollHeight;
        },
        destroyed() {
            window.removeEventListener('scroll', this.onPageScroll);
            delete this.onPageScroll;
        },
        methods: {
            onPageScroll(scrollY) {
                this.top = scrollY < 10;
            },
            toPage (viewPath) {
                this.$emit('route-change');
                this.showMenu = false;
                this.$router.push({
                    path: viewPath
                });
            }
        }
    }
</script>

<style scoped>
    .header-conainer {

        width: 100%;
        padding: 5% 5% 0 5%;
        background: #ffffff;
        box-shadow: 0 3px 0 0 rgba(0,0,0,.05);
    }

    .fixed {
        position: fixed;
        top: 0;
        z-index: 1000;
    }

    .DrawerPage {
        position: fixed;
        width: 100%;
        height: 100%;
        left: 0vw;
        background-color: #f1f1f1;
        transition: all 0.4s;
    }



    .DrawerWindow {
        position: absolute;
        height: 30vh;
        width: 42vw;
        right: 0;
        top: 0;
        margin-top: 5rem;
        transform: scale(0.9, 0.9) translateX(100%);
        opacity: 0;
        pointer-events: none;
        transition: all 0.4s;
    }

    .DrawerWindow.show {
        transform: scale(1, 1) translateX(0%);
        opacity: 1;
        pointer-events: all;
    }

    .DrawerClose {
        position: absolute;
        width: 100%;
        height: 100%;
        right: 0;
        top: 0;
        color: transparent;
        padding-bottom: 10rem;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.01), rgba(0, 0, 0, 0.6));
        letter-spacing: 5px;
        font-size: 3rem;
        opacity: 0;
        pointer-events: none;
        transition: all 0.4s;
    }

    .DrawerClose.show {
        opacity: 1;
        pointer-events: all;
        width: 100%;
        color: #fff;
    }

    .shaow{
        box-shadow: 0 0 0 100rem rgba(0, 0, 0, 0.5);
        z-index: auto;
    }

    .last-menu {
        border-bottom: 1px solid #ddd;
    }

    .menu-selected {
        background: #ff4e00 !important;
        color: #ffffff;
    }


    .mobile-header {
        background: #ffffff;
    }

    .padding-right{
        padding-right: 5px;
    }

    .ovride {
        background-color: rgba(5, 5, 5, 0.5);
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 10;
    }

</style>
